// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Funktionskarten: Icon links, kurzer Text, Voraussetzung + Link unten */
.feature-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 22rem), 1fr));
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid var(--border-primary);
  border-left: 1px solid var(--border-primary);
}

.feature-card {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.1rem 1.1rem 1rem;
  border-right: 1px solid var(--border-primary);
  border-bottom: 1px solid var(--border-primary);
  --note-ground: var(--bg-primary);
}

.feature-body {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.35rem;
  min-width: 0;
}

.feature-body h3 {
  margin: 0;
  font-family: var(--font-display);
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.15;
  text-transform: uppercase;
}

.feature-body p {
  margin: 0;
  color: var(--text-primary);
  font-size: 0.97rem;
}

.feature-foot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem 0.75rem;
  margin-top: 0.25rem;
}

.feature-req {
  padding: 0.05rem 0.4rem;
  border: 1px solid var(--border-secondary);
  font-family: var(--font-mono);
  font-size: 0.66rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.feature-more {
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;
  margin-left: auto;
  font-family: var(--font-mono);
  font-size: 0.74rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.feature-older {
  margin-top: 1rem;
}

.feature-older p {
  margin: 0;
  font-size: 0.92rem;
  color: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/product/FeaturesTab.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;EACE,aAAa;EACb,uEAAuE;EACvE,MAAM;EACN,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,6CAA6C;EAC7C,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;EACzC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B","sourcesContent":["/* Funktionskarten: Icon links, kurzer Text, Voraussetzung + Link unten */\n.feature-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(min(100%, 22rem), 1fr));\n  gap: 0;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border-top: 1px solid var(--border-primary);\n  border-left: 1px solid var(--border-primary);\n}\n\n.feature-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 1.1rem 1.1rem 1rem;\n  border-right: 1px solid var(--border-primary);\n  border-bottom: 1px solid var(--border-primary);\n  --note-ground: var(--bg-primary);\n}\n\n.feature-body {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0.35rem;\n  min-width: 0;\n}\n\n.feature-body h3 {\n  margin: 0;\n  font-family: var(--font-display);\n  font-size: 1.2rem;\n  font-weight: 600;\n  line-height: 1.15;\n  text-transform: uppercase;\n}\n\n.feature-body p {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: 0.97rem;\n}\n\n.feature-foot {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem 0.75rem;\n  margin-top: 0.25rem;\n}\n\n.feature-req {\n  padding: 0.05rem 0.4rem;\n  border: 1px solid var(--border-secondary);\n  font-family: var(--font-mono);\n  font-size: 0.66rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n}\n\n.feature-more {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.15rem;\n  margin-left: auto;\n  font-family: var(--font-mono);\n  font-size: 0.74rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.feature-older {\n  margin-top: 1rem;\n}\n\n.feature-older p {\n  margin: 0;\n  font-size: 0.92rem;\n  color: var(--text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
